'use memo'

import React from 'react'
import { ShareAltOutlined } from '@ant-design/icons'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import { TextField, FieldRow } from '../FormikField'
import EditableSection from '../EditableSection'

const SocialProfilesSection: React.FC = () => (
  <EditableSection
    id='socialProfiles'
    title={capitalizeWords('Social Profiles')}
    icon={<ShareAltOutlined />}
  >
    <FieldRow>
      <TextField
        name='facebook'
        label='Facebook'
        placeholder='facebook.com/ username'
      />
      <TextField
        name='instagram'
        label='Instagram'
        placeholder='instagram.com/ username'
      />
    </FieldRow>
    <FieldRow>
      <TextField
        name='tiktok'
        label='TikTok'
        placeholder='tiktok.com/@ username'
      />
      <TextField
        name='youtube'
        label='YouTube'
        placeholder='youtube.com/ username'
      />
    </FieldRow>
  </EditableSection>
)

export default SocialProfilesSection
